import store, { RootState } from '../store';
import { AUDIO_ASSETS, LAZY_AUDIO_ASSETS } from '../Enums/AudioAssets'
import { useAppSelector } from '../redux';
import './Components.scss';

function MusicAsset(props: {
  name: string,
  loop?: boolean,
}) {

  const asset = AUDIO_ASSETS[props.name] || LAZY_AUDIO_ASSETS[props.name] || null;
  const loop = props.loop ?? false

  const gameState = useAppSelector((state: RootState) => state.game)
  const isMuted = gameState.isMuted;

  if (!asset) {
    console.error(props.name + ' no asset!');
    return <></>;
  }



  return (
    <audio autoPlay loop={loop} id="myAudio" muted={isMuted}>
      <source src={props.name} type="audio/mpeg" />
    </audio>
  );
}

export default MusicAsset;
